import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=2f5231b4&"
import script from "./AdminDetail.vue?vue&type=script&lang=ts&"
export * from "./AdminDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports